import type { CSSProperties } from 'react'
import './Spinner.css'
import { useTheme } from '../../providers/useTheme'

type SpinnerProps = {
  variant?: 'white' | 'black'
  style?: CSSProperties
}

const getLuminance = (color: string): number => {
  const rgba = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/)
  if (!rgba) return 0.5

  const r = parseInt(rgba[1]) / 255
  const g = parseInt(rgba[2]) / 255
  const b = parseInt(rgba[3]) / 255

  const [rs, gs, bs] = [r, g, b].map((c) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4),
  )

  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs
}

export const Spinner = ({ variant, style }: SpinnerProps) => {
  const { colors } = useTheme()

  const calculatedVariant =
    variant ?? (getLuminance(colors.textPrimary) > 0.5 ? 'white' : 'black')

  return (
    <div
      className={`spinner-${calculatedVariant}`}
      style={{ transform: 'scale(0.4)', ...style }}
    />
  )
}
